import React, { useState, useCallback } from 'react';
import { getTasks } from '../../api/tasks';
import useApi from '../../hooks/useApi';
import TopBar from '../layout/TopBar';
import TasksFilters from './TasksFilters';
import TasksList from './TasksList';
import LoadingState from '../shared/LoadingState';
import ErrorState from '../shared/ErrorState';
import EntryDetailModal from '../entries/EntryDetailModal';

function TasksView({ showToast }) {
  const [filters, setFilters] = useState({ status: '', priority: '', search: '', page: 1, limit: 20 });
  const [selectedEntryId, setSelectedEntryId] = useState(null);

  const apiFn = useCallback(() => {
    const params = {};
    if (filters.status)   params.status   = filters.status;
    if (filters.priority) params.priority = filters.priority;
    if (filters.search)   params.search   = filters.search;
    params.page  = filters.page;
    params.limit = filters.limit;
    return getTasks(params);
  }, [filters]);

  const { data, meta, loading, error, refetch } = useApi(apiFn, [filters]);

  function handleTaskClick(task) {
    const entryId = task.linked_entry_id || task.entry_id;
    if (entryId) setSelectedEntryId(entryId);
  }

  const subtitle = meta ? `${meta.total} tarea${meta.total !== 1 ? 's' : ''}` : '';

  return (
    <div className="view-container">
      <TopBar title="Tareas" subtitle={subtitle} />

      <div className="view-content">
        <TasksFilters filters={filters} onChange={setFilters} />

        {loading && <LoadingState rows={6} />}
        {error   && <ErrorState message={error} onRetry={refetch} />}
        {!loading && !error && (
          <TasksList
            tasks={data || []}
            meta={meta}
            page={filters.page}
            onPageChange={p => setFilters(f => ({ ...f, page: p }))}
            onTaskClick={handleTaskClick}
          />
        )}
      </div>

      <EntryDetailModal
        entryId={selectedEntryId}
        onClose={() => setSelectedEntryId(null)}
        showToast={showToast}
      />
    </div>
  );
}

export default TasksView;
